import {
  assignAfter
} from "./chunk-ACLKCINH.mjs";

// src/system.ts
import { createElement, forwardRef } from "react";
import createStyled from "@emotion/styled";
var _a;
var emotionStyled = (_a = createStyled.default) != null ? _a : createStyled;
var cssObjectManager = (props) => {
  const { __css, css: emotionCss, sx } = props;
  const styles = assignAfter({}, sx);
  const serializedStyle = Array.isArray(__css) ? __css.filter(Boolean).map(({ styles: styles2 }) => styles2.trim()).join("\n") : `${__css ? __css == null ? void 0 : __css.styles : ""}`;
  return emotionCss ? [serializedStyle, styles, emotionCss] : [serializedStyle, styles];
};
function styled(component) {
  const Component = emotionStyled(component)(
    cssObjectManager
  );
  const juloComponent = forwardRef(function JuloComponent(props, ref) {
    return createElement(Component, {
      ref,
      ...props
    });
  });
  return juloComponent;
}

export {
  cssObjectManager,
  styled
};
